import { h, Component } from 'preact'
import BranchAPI from '../api/BranchAPI'
import ErrorMessage from '../components/ErrorMessage'
import Loader from '../components/Loader'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class BranchFilter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      branches: [],
      error: false,
      isLoading: true
    }

    this.handleBranch = this.handleBranch.bind(this)
  }

  componentDidMount() {
    this.fetchBranches()
  }

  fetchBranches() {
    this.setState({ isLoading: true })

    BranchAPI.all(this.props.slugs)
    .then(response => response.json())
    .then(data => {
      this.setState({
        branches: [...this.state.branches, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  handleBranch(e) {
    this.props.onSelectBranch(e.target.value)
  }

  generateButtons() {
    let buttons = []

    // default button
    buttons.push(this.generateDefaultButton())

    // make an button for each branch
    this.state.branches.map((branch) => {

      // skip branch if it has no cases
      if ( branch.count === 0 ) return false

      let buttonClass = 'c-case-branches__button'

      if ( this.props.currentBranch == branch.id ) {
        buttonClass = 'c-case-branches__button c-case-branches__button--active'
      }

      return buttons.push(
        <button
          className={buttonClass}
          value={branch.id}
          key={branch.id}
          onClick={this.handleBranch}
          dangerouslySetInnerHTML={{ __html: branch.name }}
        />
      )
    })

    return buttons
  }

  generateDefaultButton() {
    let defaultClass = 'c-case-branches__button'
    let default_text = 'Alle cases'

    if ( this.props.currentBranch == '' ) {
      defaultClass = 'c-case-branches__button c-case-branches__button--active'
    }

    return (
      <button className={defaultClass} value="" onClick={this.handleBranch}>
        {default_text}
      </button>
    )
  }

  render() {
    let {error, isLoading} = this.state

    if (error) {
      return <ErrorMessage type="filter-error" />
    }

    if (isLoading) {
      return <Loader />
    }

    return (
      <div className="c-case-branches">
        <div className="c-case-branches__container">
          {this.generateButtons()} 
          <div class="c-case-branches__empty" />
        </div>
      </div>
    )
  }
}

export default BranchFilter



// WEBPACK FOOTER //
// ./src/js/app/containers/BranchFilter.js